import Vue from 'vue';
import { copyToClipboard } from '@/utils/other';
export default Vue.extend({
    name: 'onCreateKeyPopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data: () => ({
        copied: {
            api: false,
            secret: false
        }
    }),
    methods: {
        copyApi() {
            const vm = this;
            copyToClipboard(vm.slotData.api).then(() => {
                vm.copied.api = true;
                vm.copied.secret = false;
            });
        },
        copySecret() {
            const vm = this;
            copyToClipboard(vm.slotData.secret).then(() => {
                vm.copied.api = false;
                vm.copied.secret = true;
            });
        }
    }
});
